export default "__VITE_ASSET__CmySS1sT__"